module.exports = __webpack_public_path__ + "img/4.d4615ab8.jpg";